import React from 'react';
import { IconPackage, IconSnowflake, IconThermometer } from '@tabler/icons-react';

const OPTIONS = [
  { value: 'dry', label: 'Secco', hint: 'All’asciutto', Icon: IconPackage, iconClass: 'text-amber-600', selectedClass: 'border-amber-500 bg-amber-50 text-amber-800 ring-amber-400' },
  { value: 'fresh', label: 'Fresco', hint: '0–4 °C', Icon: IconThermometer, iconClass: 'text-cyan-600', selectedClass: 'border-cyan-500 bg-cyan-50 text-cyan-800 ring-cyan-400' },
  { value: 'frozen', label: 'Surgelato', hint: 'Congelato', Icon: IconSnowflake, iconClass: 'text-blue-600', selectedClass: 'border-blue-500 bg-blue-50 text-blue-800 ring-blue-400' },
];

export default function StorageClassSelect({ value, onChange, compact = false }) {
  return <div className="grid grid-cols-3 gap-1.5" role="group" aria-label="Conservazione">
    {OPTIONS.map(({ value: option, label, hint, Icon, iconClass, selectedClass }) => {
      const selected = value === option;
      return <button key={option} type="button" aria-pressed={selected} aria-label={`${label}, ${hint}`}
        onClick={() => onChange(option)}
        className={`${compact ? 'min-h-11 md:min-h-10' : 'min-h-12 sm:min-h-12'} flex min-w-0 items-center justify-center gap-1 rounded-lg border px-1 text-xs font-medium transition-colors sm:gap-1.5 sm:px-2 ${selected ? `${selectedClass} ring-1` : 'border-slate-200 bg-white text-slate-700 hover:border-slate-300 hover:bg-slate-50'}`}>
        <Icon className={`h-4 w-4 shrink-0 ${iconClass}`} aria-hidden="true"/>
        <span className="min-w-0 text-center leading-tight">{label}<span className={`${compact ? 'hidden lg:block' : 'block'} text-[10px] opacity-75`}>{hint}</span></span>
      </button>;
    })}
  </div>;
}
